import { render } from "./SliderCommand.vue?vue&type=template&id=94203510&scoped=true"
import script from "./SliderCommand.vue?vue&type=script&lang=js"
export * from "./SliderCommand.vue?vue&type=script&lang=js"

import "./SliderCommand.vue?vue&type=style&index=0&id=94203510&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94203510"]])

export default __exports__